import { HttpMethod } from '@/lib/types/httpMethod'
import { getBaseUrl } from '@/lib/utils/path.utils'
import { generateTraceId } from '@/lib/utils/random.util'

export const contactFormApply = (tenantId: string, jobOpeningId: number, firstName: string, lastName: string, email: string, locale: string) => {
  const url = `${getBaseUrl()}/api/internal/contactform/apply`
  const traceId = generateTraceId()
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Authorization', 'Basic ' + Buffer.from(`${process.env.SERVICE_API_USER}:${process.env.SERVICE_API_PASSWORD}`).toString('base64'))
  headers.append('X-ORIGIN', 'ATTRACT')
  headers.append('X-TRACE-ID', traceId)
  headers.append('X-HTTP-REQUEST-ID', traceId)

  const data = {
    tenantId,
    jobOpeningId,
    firstName,
    lastName,
    email,
    locale
  }

  return fetch(url, {
    method: HttpMethod.POST,
    headers: headers,
    body: JSON.stringify(data)
  })
}
